import { __module as e } from "../../../_virtual/isCreditCard.js";
import { a as r } from "./util/assertString.js";
Object.defineProperty(t = e.exports, "__esModule", {
  value: !0
}), t.default = function (e) {
  (0, a.default)(e);
  var r,
    t,
    d = e.replace(/[- ]+/g, "");
  if (!s.test(d)) return !1;
  for (var o = 0, u = d.length - 1; u >= 0; u--) r = parseInt(d.substring(u, u + 1), 10), t && (r *= 2) >= 10 ? o += r % 10 + 1 : o += r, t = !t;
  return !!(o % 10 == 0 && d);
}, a = r && r.__esModule ? r : {
  default: r
}, s = /^(?:4[0-9]{12}(?:[0-9]{3,6})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12,15}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14}|^(81[0-9]{14,17}))$/, e.exports = t.default, e.exports.default = t.default;
var t,
  a,
  s,
  d = e.exports;
export { d as i };